import ImageOptimizer from '@/components/image-optimizer';
import { slugify } from '@/lib/utils';
import { StoreEntity, StoreType } from '@/services/types/store.type';
import Link from 'next/link';

const BranchCard = (branch: StoreEntity) => {
  // const { data: keywordList } = useKeywordList();
  // const keywords = keywordList?.data || [];

  const branchSlug = slugify(branch.name, branch.id);
  return (
    <Link
      href={`/branch/${branchSlug}`}
      className="block w-full overflow-hidden transition"
    >
      {/* 1. 이미지 */}
      <div className="desktop:aspect-[372/219] relative aspect-[452/260] w-full overflow-hidden rounded-lg">
        <ImageOptimizer
          src={branch.photoPath ?? ''}
          alt={branch.name + ' 썸네일'}
          fill
          className="object-cover"
        />
        {branch.summaryAddress && branch.summaryAddress.length > 0 && (
          <>
            <span className="bg-sub-white/75 text-level-2 typo-16 absolute bottom-4 left-1/2 flex max-w-full -translate-x-1/2 justify-center overflow-hidden rounded-full border border-white px-3 py-2 font-bold text-ellipsis whitespace-nowrap">
              <div className="relative size-4 h-auto flex-shrink-0">
                <ImageOptimizer
                  src="/images/icons/icon_map_pin.svg"
                  alt="위치"
                  fill
                />
              </div>
              <span className="truncate">{branch.summaryAddress}</span>
            </span>
          </>
        )}
      </div>

      {/* 2. 정보 섹션 */}
      <div className="desktop:pt-5 pt-4 text-left">
        <div className="desktop:mb-3 mb-2.5 flex items-center">
          <h3 className="typo-20 text-level-1 desktop:typo-24 truncate font-extrabold">
            {branch.name}
          </h3>
          {branch?.type === StoreType.DIRECT && (
            <span className="bg-main-yellow text-level-1 typo-14 ml-2 inline-block rounded-sm px-2 py-1 text-center leading-[15px] font-bold">
              직영점
            </span>
          )}
        </div>

        <div className="typo-16 text-level-4 desktop:typo-18 flex items-start font-bold">
          <ImageOptimizer
            src="/images/icons/icon_map_pin.svg"
            alt="위치"
            width={16}
            height={16}
            className="size-4 h-auto pt-0.5"
          />
          <p className="ml-1 leading-snug">{branch.address}</p>
        </div>

        {/* 3. 해시태그 */}
        {branch.keywordTags && branch.keywordTags.length > 0 && (
          <div className="mt-3.5 flex flex-wrap gap-1">
            {branch.keywordTags.split(',').map((keyword) => (
              <span
                key={keyword}
                className="text-font-grayblue typo-13 desktop:typo-14 desktop:px-3 rounded-lg bg-gray-100 px-2 py-2 font-semibold"
              >
                {/* #{keywordTags.find((item) => item.value === keyword)?.label} */}
                #{keyword}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default BranchCard;
